<template>
  <div class="tree">
    <div class="custom-tree-container">
      <el-input
          v-model="filterText"
          style="width: 300px; margin-left: 10px"
          placeholder="输入关键字进行过滤"/>
      <div style="margin: 10px 40px 20px 10px;">
        <el-button v-if="addAuth && !parentDisable" style="margin-bottom: 5px" type="primary" @click="$refs.edit.open(1, null, 0, treeList.length + 1)">新建一级</el-button>
        <el-tree
            ref="tree"
            v-loading="loading"
            :data="treeList"
            default-expand-all
            :filter-node-method="filterNode"
            node-key="id"
            :expand-on-click-node="false">
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{data.label}}</span>
            <span>
              <el-button
                  v-if="addAuth"
                  type="text"
                  style="margin-left: 40px;"
                  icon="el-icon-circle-plus"
                  @click="append(node, data)"/>
              <el-button
                  v-if="editAuth"
                  type="text"
                  style="margin-left: 10px;"
                  icon="el-icon-edit"
                  :disabled="data.parentId === 0 && parentDisable"
                  @click="edit(node, data)"/>
              <el-button
                  v-if="delAuth"
                  type="text"
                  style="margin-left: 10px;"
                  icon="el-icon-delete"
                  :disabled="data.parentId === 0 && parentDisable"
                  @click="remove(data)"/>
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <vm-tree-type-edit ref="edit" :category="category" @save-success="getData()"/>
  </div>
</template>
<script>
  import VmTreeTypeEdit from "@/components/treeType/VmTreeTypeEdit.vue";

  export default {
    name:"VmTreeType",
    components: {VmTreeTypeEdit},
    props: {
      category: {
        type: Number,
        required: true,
      },
      addAuthIndex: {
        type: Number,
        required: false,
      },
      editAuthIndex: {
        type: Number,
        required: false,
      },
      delAuthIndex: {
        type: Number,
        required: false,
      },
      parentDisable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        addAuth: this.$auth(this.addAuthIndex),
        editAuth: this.$auth(this.editAuthIndex),
        delAuth: this.$auth(this.delAuthIndex),
        loading: false,
        treeList: [],
        filterText: "",
      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.loading = true;
        let param = {
          category: this.category,
        };
        this.$http
          .get("basic","treeTypes", param).then((res) => {
            this.treeList = res;
            this.$nextTick(() => {
              this.$refs.tree.filter(this.filterText);
            });
          }).finally(() => {
            this.loading = false;
          });
      },
      filterNode(value, data, node) {
        if (!value) {
          return true;
        }
        if (node.parent.parent !== null && node.parent.visible) {
          return true;
        }
        return data.label.indexOf(value) !== -1;
      },
      append(node, data) {
        this.$refs.edit.open(0, null, data.id, node.childNodes.length + 1);
      },
      edit(node, data) {
        this.$refs.edit.open(0, data.id, node.parent.data.id);
      },
      remove(data) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","treeTypes", data.id).then(() => {
            this.getData();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.tree{
  .custom-tree-node {
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
}

</style>
